import { axiosAuth } from "@shared/api/base/axiosAuth";
import { API_PATHS } from "@shared/api/constants";

export const profileData = async () => axiosAuth.get(API_PATHS.PROFILE_INFO);

export const profileSetAvatar = async (formData) =>
  axiosAuth.post(`${API_PATHS.PROFILE_INFO}avatar/`, formData);
